import React, { Component } from 'react'
import { connect } from 'react-redux'
import CalculationLinearDrainageDesktop from './CalculationLinearDrainageDesktop'
import CalculationLinearDrainageMobile from './CalculationLinearDrainageMobile'
import { withGetScreen } from 'react-getscreen'

class CalculationLinearDrainage extends Component {
  render() {
    if (this.props.isMobile()) {
      return <CalculationLinearDrainageMobile />
    } else {
      return <CalculationLinearDrainageDesktop />
    }
  }
}

const options = { mobileLimit: 900, shouldListenOnResize: true }
export default connect()(withGetScreen(CalculationLinearDrainage, options))
